/**
 * 將字串陣列篩選掉空值，並組成文字
 */
export function joinText(
  textList: (string | undefined | null)[],
  sign: string
): string {
  return textList.filter((value): value is string => !!value).join(sign)
}
